import {
  Badge,
  Box,
  Flex,
  FormControl,
  FormLabel,
  Spinner,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { usePendingFamilyCards } from "api/users";
import Link from "generics/Link";
import PageTitle from "generics/PageTitle";
import ToolbarPortal from "generics/ToolbarPortal";
import { useAuth } from "providers/AuthProvider";
import React, { useState } from "react";
import { updateLab } from "api/auth";

export default function FamilyCardPage() {
  const familyCardsQuery = usePendingFamilyCards();

  const { lab } = useAuth();
  const [discountCard, setDiscountCard] = useState(lab?.discountCard ?? false);

  function getColorScheme(status: string) {
    if (status === "pending") return "yellow";
    if (status === "rejected") return "red";
    if (status === "accepted") return "green";
  }

  return (
    <Box>
      <ToolbarPortal>
        <Flex justifyContent="space-between" alignItems="center">
          <PageTitle>Discount Cards</PageTitle>
          <FormControl
            display="flex"
            alignItems="center"
            width="18%"
            marginleft="auto"
          >
            <FormLabel htmlFor="email-alerts" mb="0">
              Discount Card
            </FormLabel>
            <Switch
              id="email-alerts"
              colorScheme="primary"
              // style={{background:"#2cb9a9"}}
              isChecked={discountCard}
              onChange={async (e) => {
                setDiscountCard(e.target.checked);
                await updateLab({ discountCard: e.target.checked });
              }}
            />
          </FormControl>
        </Flex>
      </ToolbarPortal>
      <Box px={12} py={6}>
        <Table>
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Name</Th>
              <Th>Status</Th>
              <Th>Documents</Th>
              <Th>Discount</Th>
            </Tr>
          </Thead>
          <Tbody>
            {familyCardsQuery.isLoading ? (
              <Tr>
                <Td colSpan={4} textAlign="center">
                  <Spinner />
                </Td>
              </Tr>
            ) : familyCardsQuery.data?.length ? (
              familyCardsQuery.data?.map((familyCard: any) => (
                <Tr key={familyCard.id}>
                  <Td>
                    {familyCard?.user?.readableId ? (
                      <Link to={"/discountcards/" + familyCard.id}>
                        {familyCard.user.readableId}
                      </Link>
                    ) : (
                      <p>-</p>
                    )}
                  </Td>
                  <Td>
                    {familyCard?.user?.name ? (
                      <Link to={"/discountcards/" + familyCard.id}>
                        {familyCard.user.name}
                      </Link>
                    ) : (
                      <p>-</p>
                    )}
                  </Td>
                  <Td>
                    <Badge colorScheme={getColorScheme(familyCard.status)}>
                      {familyCard.status}
                    </Badge>
                  </Td>
                  <Td>{familyCard.documents?.length}</Td>
                  <Td>{familyCard.discount}%</Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={4}>
                  <Text>No Discount Cards</Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
}
